import { colors } from "./colors";
export function highlightMarkSpec() {
    return {
        highlight: {
            attrs: {
                color: { default: null },
            },
            parseDOM: [
                {
                    style: "background-color",
                    getAttrs: (color) => {
                        const colorOption = colors.find((option) => option.value === color);
                        if (!colorOption) {
                            return false;
                        }
                        return { color: colorOption.class };
                    },
                },
                {
                    tag: "span.text-highlight",
                    getAttrs: (node) => {
                        const className = node.className;
                        const colorOption = colors.find((option) => className.includes(option.class));
                        if (!colorOption) {
                            return false;
                        }
                        return { color: colorOption.class };
                    },
                },
            ],
            toDOM: (node) => {
                const attrs = node.attrs;
                const colorOption = colors.find((option) => option.class === attrs.color);
                if (!colorOption) {
                    return ["span", 0];
                }
                return [
                    "span",
                    {
                        class: `text-highlight text-highlight--${colorOption.class}`,
                        style: `background-color: ${colorOption.value}`,
                    },
                    0,
                ];
            },
        },
    };
}
